import { BaseResource } from "utils/ApiUtils";


export default class FieldFormResultDetails extends BaseResource {
  constructor(args) {
    super(args, FieldFormResultDetails.attributes);
  };

  static columns = [
    { title: "Supplier", field: "Supplier_FieldMaterial" },
    { title: "Material Desc", field: "MaterialDesc_FieldMaterial" },
    { title: "Code", field: "MaterialCode_FieldMaterial" },
    { title: "Spec Item", field: "SpecItem_FieldMaterial" },
    { title: "Category", field: "Category_FieldMaterial" },
    { title: "Subcategory", field: "MaterialSub_FieldMaterial" },
    { title: "Test Result", field: "Description_TestResults" },
    { title: "Retest Required", field: "Description_Retest" },
    { title: "Sample Type", field: "Description_AnalysisType"},
    { title: "Location Description", field: "Description_Station" },
    // { title: "Elevation", field: "Elevation", sorting: false },
    // { title: "Station", field: "Station", sorting: false },
    // { title: "StationA", field: "StationPartA", sorting: false, hidden: true },
    // { title: "StationB", field: "StationPartB", sorting: false, hidden: true },
    // { title: "Offset Distance", field: "OffsetDistance", sorting: false },
    // { title: "Offset Direction", field: "Description_Direction"},
    { title: "Location Details", field: "LocationDetails", sorting: false },
    { title: "Comments", field: "Comments" },
    { title: "Attachments", field: "XrefFieldTest", sorting: false, hidden: true }

  ]

  static attributes = FieldFormResultDetails.columns.map(r => r.field);

  static expand = [
    {
      "MaterialForm": {
        "expand": [
          {
            "Form": {
              select: ["TestType"]
            }
          },
          {
            "FieldMaterial": {
              select: ["Supplier", "MaterialSub", "MaterialDesc", "MaterialCode", "MaterialCode", "SpecItem", "Supplier", "Category"]
            }
          },
        ]
      },
      "Retest": {
        select: ["Description"],
      }
      ,
      "TestResults": {
        select: ["Description"],
      },
      "XrefFieldTest": {
        select: ["*"]
      },
      "Station": {
        select: ["Description"]
      },
      // "Direction": {
      //   select: ["Description"]
      // },
      "AnalysisType": {
        select: ["Description"]
      },
    }
  ]
}
